<div class="body">

    <ng-container *ngIf="counter > 0; else noUploads">

        <div *ngFor="let file of files" class="file-entry">

            <div class="status-indicator">
                <mat-spinner *ngIf="(step.status|async) === StepStatus.Started" diameter=20></mat-spinner>
                <mat-icon *ngIf="(step.status|async) === StepStatus.Succeeded">done</mat-icon>
                <mat-icon *ngIf="(step.status|async) === StepStatus.Failed">clear</mat-icon>
            </div>
            <div class="name">{{file.name}}</div>
            <div class="size">{{file.size|fileSize}}</div>

        </div>

    </ng-container>

</div>

<ng-template #noUploads>

    <div class="no-entries-hint">

        <div class="text">Keine Dateien zum Hochladen</div>

    </div>

</ng-template>
